// @ts-ignore
import handlebars from 'handlebars/dist/handlebars';
import registerHelpers from './handlebars.helper';
window.Handlebars = handlebars;
registerHelpers(window.Handlebars, {
    publicPath: window.PGB_PUBLIC_PATH,
    assetPath: window.PGB_ASSET_PATH,
});
